<div class="report-tree-container">
  <div class="tree-header d-flex">
    <div>
      <h4 class="mb-3">
        <i class="fa fa-sitemap text-primary mr-2"></i>
        Report Tree
      </h4>
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <div class="d-flex justify-content-center my-2">
        <div>
          <span class="font-weight-bold pr-3">Hide archived categories</span>
          <input id="hideArchivedCategories" type="checkbox" class="form-check-input" [(ngModel)]="hideArchivedCategories" data-testid="report-type-editor-hide-archived-categories-checkbox"/>
        </div>
      </div>
      <div class="tree-content">
        <ul class="tree-root">
          <app-report-type-editor-item
            *ngFor="let root of reportTree"
            [hidden]="hideArchivedCategories && root.isActive === false && !root.sourceId && !root.sourceName"
            [node]="root"
            [nestingLevel]="0"
            [selectedNode]="selectedNode"
            [expandFavorites]="expandFavorites"
            [hideArchivedCategories]="hideArchivedCategories"
            (nodeClick)="onNodeClick($event)"
            (openNewCategoryModal)="onOpenNewCategoryModal($event)"
            (openEditCategoryModal)="onOpenEditCategoryModal($event)"
            (toggleCategoryActive)="onToggleCategoryActive($event)"
            (duplicateReportType)="onDuplicateReportType($event)"
            [attr.data-testid]="'report-type-editor-item-' + root.id"></app-report-type-editor-item>
        </ul>
      </div>
    </div>
    <div class="col border-left pl-4 pt-4">
      <form [formGroup]="reportTypeForm" *ngIf="selectedNode" (ngSubmit)="onSubmit()" data-testid="report-type-editor-report-type-form">
      <div class="d-flex justify-content-between">
        <h4 class="mb-3">
          <span *ngIf="selectedReportType" >
            <i class="fa-light fa-file-chart-column"></i>
            Report Editor
          </span>
          <span *ngIf="!selectedReportType" class="text-primary" >
            <i class="fa-light fa-file-chart-column"></i>
            New Report Creator
          </span>
        </h4>
        <div class="form-group">
          <button class="btn btn-primary" type="submit" *ngIf="selectedReportType" [disabled]="!reportTypeForm.valid" data-testid="report-type-editor-save">Save</button>
          <button class="btn btn-primary" type="submit" *ngIf="!selectedReportType" [disabled]="!reportTypeForm.valid" data-testid="report-type-editor-add">Add</button>
        </div>
      </div>
        <div class="form-row">
          <div class="col-4 company-name">
            <div class="card h-100">
              <div class="card-body h-100">
                <div class="card-title font-weight-bold">
                  <i class="fa fa-circle-info" aria-hidden="true"></i>
                  Details
                </div>
                <div class="card-text h-100">
                  <ul class="card-table h-100">
                    <li>
                      <div class="form-group">
                        <label for="reportName">
                          Report Name <span class="text-danger">*</span>
                        </label>
                        <input 
                          id="reportName" type="text" 
                          class="form-control" 
                          formControlName="reportName" 
                          maxlength="100" 
                          [class.is-invalid]="reportTypeForm.get('reportName')?.touched &&
                                              reportTypeForm.get('reportName')?.invalid" data-testid="report-type-editor-report-name"/>

                        <div class="invalid-feedback">
                          Report Name is required.
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="reportSourceId">
                          Report Source <span class="text-danger">*</span>
                        </label>

                        <select
                          id="reportSourceId"
                          class="form-control"
                          formControlName="reportSourceId"
                          [class.is-invalid]="reportTypeForm.get('reportSourceId')?.touched &&
                                              reportTypeForm.get('reportSourceId')?.invalid" data-testid="report-type-editor-report-source">

                          <option [ngValue]="null">Select source...</option>
                          <option *ngFor="let source of reportTypeSources"
                                  [ngValue]="source.id">
                            {{ source.sourceName }}
                          </option>
                        </select>

                        <div class="invalid-feedback">
                          Report Source is required.
                        </div>
                      </div>
                      <div class="form-group" title="Checking this box will hide the report from the user facing interface as these are programmatically receiving parameters and will not work in the report tree interface.">
                        <span class="font-weight-bold pr-3">System Integrated Report</span>
                        <input id="isSystem" type="checkbox" class="form-check-input" formControlName="isSystem" data-testid="report-type-editor-system-checkbox"/>
                      </div>
                      <div class="form-group" title="Checking this box will enable the system to save historical versions of this report for recall.">
                        <span class="font-weight-bold pr-3">Save Report Versions</span>
                        <input id="isSaved" type="checkbox" class="form-check-input" formControlName="isSaved" data-testid="report-type-editor-saved-checkbox"/>
                      </div>
                      <div class="form-group  ">
                        <label for="tooltipDescription">
                          Tooltip Description <span class="text-danger">*</span>
                        </label>

                        <textarea
                          id="tooltipDescription"
                          rows="3"
                          class="form-control"
                          formControlName="tooltipDescription"
                          maxlength="250"
                          [class.is-invalid]="reportTypeForm.get('tooltipDescription')?.touched &&
                                              reportTypeForm.get('tooltipDescription')?.invalid" data-testid="report-type-editor-tooltip-description">
                        </textarea>

                        <div class="invalid-feedback">
                          Tooltip Description is required.
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 company-name">
            <div class="card h-100">
              <div class="card-body h-100">
                <div class="card-title font-weight-bold">
                  <i class="fa fa-folders" aria-hidden="true"></i>
                  Location
                </div>
                <div class="card-text h-100">
                  <ul class="card-table h-100">
                    <li>
                      <div class="form-group">
                        <label for="divisionId">Division</label>
                        <select id="divisionId" class="form-control" formControlName="divisionId" disabled data-testid="report-type-editor-division">
                          <option [ngValue]="null">Select division...</option>
                          <option *ngFor="let division of divisionList" [ngValue]="division.id">
                            {{ division.divisionName }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="reportCategoryId">Report Category</label>
                        <select
                          id="reportCategoryId"
                          class="form-control"
                          formControlName="reportCategoryId" data-testid="report-type-editor-report-category">                          
                          <option
                            *ngFor="let category of categoryList"
                            [ngValue]="category.id">
                            {{ category.name }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="reportPath">
                          Report Path <span class="text-danger">*</span>
                        </label>

                        <input
                          id="reportPath"
                          type="text"
                          class="form-control"
                          formControlName="reportPath"
                          maxlength="500"
                          [class.is-invalid]="reportTypeForm.get('reportPath')?.touched &&
                                              reportTypeForm.get('reportPath')?.invalid" data-testid="report-type-editor-report-path"/>

                        <div class="invalid-feedback">
                          Report Path is required.
                        </div>

                        <small class="form-text text-muted">
                          <br />
                          For Telerik:<br />
                          {{ '{0} - {Division Name}/{Report Category}/{Report Name}.trdp' }}<br />
                          <br />
                          For PowerBI:<br />
                          {{ 'https://app.powerbi.com/reportEmbed?reportId={ReportID}&autoAuth=true&ctid={ctid}' }}<br />
                          <br />
                          For External Link:<br />
                          {{ 'https://docs.google.com/spreadsheets/d/{docID}/' }}
                        </small>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 company-name">
            <div class="card h-100">
              <div class="card-body h-100">
                <div class="card-title font-weight-bold">
                  <i class="fa fa-wave-pulse" aria-hidden="true"></i>
                  Status
                </div>
                <div class="card-text h-100">
                  <ul class="card-table h-100">
                    <li>
                      <div class="form-group">
                        <label for="startDate">
                          Start Date <span class="text-danger">*</span>
                        </label>

                        <input
                          id="startDate"
                          type="date"
                          class="form-control"
                          formControlName="startDate"
                          [class.is-invalid]="reportTypeForm.get('startDate')?.touched &&
                                              reportTypeForm.get('startDate')?.invalid" data-testid="report-type-editor-start-date"/>

                        <div class="invalid-feedback">
                          Start Date is required.
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="endDate">End Date</label>
                        <input id="endDate" type="date" class="form-control" formControlName="endDate" data-testid="report-type-editor-end-date"/>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 company-name my-2">
            <div class="card h-100">
              <div class="card-body h-100">
                <div class="card-title font-weight-bold">
                  <i class="fa fa-notes" aria-hidden="true"></i>
                  Notes
                </div>
                <div class="card-text h-100">
                  <ul class="card-table h-100">
                    <li>
                      
              
                      <div class="form-group  ">
                        <label for="internalNotes">Internal Notes</label>
                        <textarea id="internalNotes" rows="3" class="form-control reportNotes" formControlName="internalNotes" maxlength="500" data-testid="report-type-editor-internal-notes"></textarea>
                      </div>
              
                    <div class="form-group  ">
                        <label for="externalNotes">
                          External Notes <span class="text-danger">*</span>
                        </label>

                        <textarea
                          id="externalNotes"
                          rows="3"
                          class="form-control reportNotes"
                          formControlName="externalNotes"
                          maxlength="500"
                          [class.is-invalid]="reportTypeForm.get('externalNotes')?.touched &&
                                              reportTypeForm.get('externalNotes')?.invalid" data-testid="report-type-editor-external-notes">
                        </textarea>

                        <div class="invalid-feedback">
                          External Notes is required.
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="form-group">
          <button class="btn btn-primary" type="submit" *ngIf="selectedReportType" [disabled]="!reportTypeForm.valid || isSaving" data-testid="report-type-editor-save-selected-report">Save</button>
          <button class="btn btn-primary" type="submit" *ngIf="!selectedReportType" [disabled]="!reportTypeForm.valid || isSaving" data-testid="report-type-editor-add-selected-report">Add</button>
          <button class="btn btn-secondary" type="button" [disabled]="isSaving" (click)="onCancel()" data-testid="report-type-editor-cancel">Cancel</button>
        </div>
      </form>
    </div>
  </div>
<app-report-category-name-modal
  [categoryList]="categoryList" 
  [reportTree]="reportTree" 
  [divisionList]="divisionList" 
  (saveCategory)="onCategorySaved($event)"
></app-report-category-name-modal>



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/report-type-editor/report-type-editor.component.html